<template>
  <b-card class="text-center">
    <b-card-title class="font-weight-bold text-left">{{
      provider.name
    }}</b-card-title>

    <b-card-text class="text-secondary text-left">
      {{ provider.link }}
    </b-card-text>
    <b-button
      class="text-center"
      variant="primary"
      block
      @click="goToProviderLink(provider.link)"
      ><b-spinner small v-if="loading"></b-spinner>
      <div v-else>Enquire</div></b-button
    >
  </b-card>
</template>
<script>
export default {
  props: {
    provider: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      loading: false
    }
  },

  methods: {
    goToProviderLink(link) {
      this.loading = true
      window.location.href = link
    }
  }
}
</script>
<style lang="scss" scoped>
.card {
  width: 342px;
  height: 211px;
}
.card-title {
  height: 1.25em;
  overflow: hidden;
}
.card-text {
  height: 3em;
  overflow: hidden;
}
</style>
